export enum msWhoInfluencedDmtDecision {
  Neurologist = 'Neurologist',
  MSNurse = 'MS Nurse',
  Me = 'Me',
  OtherMSPatients = 'Other MSers',
  NotApplicable = 'Not applicable',
  Other = 'Other',
}


const MSWhoInfluencedDmtDecisionList = [
  msWhoInfluencedDmtDecision.Neurologist,
  msWhoInfluencedDmtDecision.MSNurse,
  msWhoInfluencedDmtDecision.Me,
  msWhoInfluencedDmtDecision.OtherMSPatients,
  msWhoInfluencedDmtDecision.NotApplicable,
  msWhoInfluencedDmtDecision.Other
];

export default MSWhoInfluencedDmtDecisionList;
